// extracted by mini-css-extract-plugin
export default {"transparencyDataTable":"transparency-module__transparencyDataTable--r5852"};